import { gameId, topNumber } from '../constants/activity-constants'

import GameServices from './game-service'
import UserSessionService from './user-session-service'

export type DTO_TopUser = {
  email?: string 
  name?: string
  point?: number
  position?: number
}
export type DTO_TopData = {
  userdata: DTO_TopUser | null
  toplist: DTO_TopUser[]
  message: string | null
  error?: boolean
}
class TopService {
  static current_request: Promise<DTO_TopData> | null = null
  static async getTop(): Promise<DTO_TopData> {
    if (this.current_request !== null) {
      return this.current_request
    }
    this.current_request = this.requestTop()
    return this.current_request
  }
  static async requestTop(): Promise<DTO_TopData> {
    let tokenId = UserSessionService.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }
    const res = await GameServices.getTopPagination(
      gameId!,
      topNumber,
      0,
      config
    )
    if (res.status === 200) {
      return {
        userdata: {
          point: res.data.point,
          position: res.data.position,
        },
        toplist: res.data.topGame.map((user: any, idx: number) => {
          return {
            email: user.email,
            name: user.name,
            point: user.point,
            position: idx + 1,
          }
        }),
        message: null,
      }
    }
    return {
      userdata: null,
      toplist: [],
      message: res.userMessage,
      error: true,
    }
  }
}

export default TopService
